var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7526_4185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 28H5.25C2.35025 28 0 25.6497 0 22.75V5.25C0 2.35025 2.35025 0 5.25 0H22.75C25.6497 0 28 2.35025 28 5.25V22.75C28 25.6497 25.6497 28 22.75 28Z",
    fill: "#619BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9199 8.25727H17.6679L18.0354 7.96359C18.3003 7.75195 18.3988 7.40906 18.2872 7.08914C18.1748 6.76922 17.8836 6.5625 17.5457 6.5625H14.0421C13.7041 6.5625 13.4129 6.76922 13.3005 7.08914C13.1882 7.40906 13.2874 7.75277 13.5524 7.96359L13.9199 8.25727Z",
    fill: "#C2D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83156 13.1258C6.68227 13.1291 6.5625 13.2505 6.5625 13.3998V18.3208C6.5625 18.4718 6.68473 18.594 6.83566 18.594H7.99641C8.11863 18.594 8.22609 18.5128 8.25973 18.3955L9.46969 14.1307C9.54762 13.855 9.39996 13.5655 9.1309 13.4679C8.63543 13.2866 7.875 13.1086 6.83156 13.1258Z",
    fill: "#EFF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.947 14.1405C13.0077 14.1758 13.07 14.2119 13.1348 14.2488L13.1939 14.257C14.0446 14.3792 15.7155 14.6179 16.0666 15.7975H16.7393C17.4169 15.5244 18.051 15.3119 18.5932 15.3119C18.6383 15.3119 18.6802 15.3201 18.7245 15.3226C19.3807 14.8148 19.6867 13.9691 19.6867 13.1274C19.6867 11.7911 18.923 10.171 17.8959 9.09888H13.7353C12.6976 10.2202 12.0307 11.9043 12.0307 13.1274C12.0307 13.3169 12.0479 13.5064 12.0791 13.6918C12.4007 13.8272 12.6722 13.9814 12.947 14.1405Z",
    fill: "#C2D8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.594 16.1331C17.5005 16.1331 15.3128 17.5178 14.2193 17.5178C13.1258 17.5178 11.8945 16.6794 11.8945 16.6794C11.8945 16.6794 13.3678 16.9526 14.2185 16.9526C15.0691 16.9526 15.312 16.6622 15.312 16.2692C15.312 15.3119 13.6861 15.1635 12.8641 15.0388C12.057 14.5892 11.6378 14.2341 10.3007 14.1208C10.2925 14.1988 10.2802 14.2759 10.2588 14.3538L9.16043 18.2257C10.4048 18.7909 12.5475 19.6875 13.6721 19.6875C15.3128 19.6875 19.6875 17.4997 19.6875 16.9534C19.6875 16.4062 19.1404 16.1331 18.594 16.1331Z",
    fill: "#EFF9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7526_4185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanner);
export default __webpack_public_path__ + "static/media/Planner.d46f19573c1131b517cda1b53c93d4f6.svg";
export { ForwardRef as ReactComponent };